import React, { useRef, useState } from '../../../../../_snowpack/pkg/react.js';
import { useLocation, useHistory } from '../../../../../_snowpack/pkg/react-router-dom.js';
import { useLanguage, useTenantLanguages, useOnClickOutside } from '../../../../hooks/index.js';
import classNames from '../../../../../_snowpack/pkg/classnames.js';

function Multilingual({
  handleClose
}) {
  const {
    language,
    setLanguage
  } = useLanguage();
  const availableLanguages = useTenantLanguages();
  const location = useLocation();
  const history = useHistory();
  const [filterString, setFilterString] = useState('');
  const wrapperRef = useRef(null);
  useOnClickOutside(wrapperRef, handleClose);
  const selectedLang = availableLanguages.find(lang => {
    return lang.code === language;
  });

  if (!availableLanguages.length) {
    return null;
  }

  const handleFilter = event => {
    setFilterString(event.target.value);
  };

  const handleLanguageSelection = code => event => {
    event.stopPropagation();
    setLanguage(code);
    handleClose();
    const firstPath = location.pathname.match(/^(\/[^/]+)/);
    history.replace(firstPath ? firstPath[0] : '/');
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "p-2",
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement("h6", {
    className: "m-0 mb-4 font-sans text-xs font-bold text-label"
  }, "Language"), /*#__PURE__*/React.createElement("ul", {
    className: "m-0 border-0 border-b border-solid border-neutral-100 p-0 pb-1"
  }, availableLanguages === null || availableLanguages === void 0 ? void 0 : availableLanguages.filter(({
    code,
    name
  }) => {
    return code.toLowerCase().includes(filterString.toLowerCase()) || name.toLowerCase().includes(filterString.toLowerCase());
  }).map(({
    code,
    name
  }) => {
    return /*#__PURE__*/React.createElement("li", {
      key: code,
      className: classNames('flex cursor-pointer items-center gap-4 p-1.5 text-sm hover:bg-neutral-100', {
        'font-medium': code === language
      }),
      onClick: handleLanguageSelection(code),
      "data-cypress": `${name}-language`
    }, /*#__PURE__*/React.createElement("span", {
      className: "w-1/6 font-bold uppercase text-[#828a90]"
    }, code), /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, name));
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-2 flex gap-4 p-1.5"
  }, /*#__PURE__*/React.createElement("label", {
    className: "w-1/6 text-sm font-bold uppercase text-[#828a90]",
    htmlFor: "language"
  }, selectedLang === null || selectedLang === void 0 ? void 0 : selectedLang.code), /*#__PURE__*/React.createElement("input", {
    className: "w-5/6 flex-shrink border-0 bg-transparent p-0  text-sm text-black-text outline-none placeholder:italic placeholder:text-label",
    name: "language",
    onChange: handleFilter,
    placeholder: selectedLang === null || selectedLang === void 0 ? void 0 : selectedLang.name,
    type: "text",
    value: filterString
  })));
}

export default Multilingual;